export const standardColours = {
  black: '#000',
  white: '#FFF',
  transparentBlack: value => {
    return `rgba(0, 0, 0, ${value})`;
  },
  transparentWhite: value => {
    return `rgba(255, 255, 255, ${value})`;
  },
  transparent: 'rgba(255, 255, 255, 0)',
  red: '#ff144f',
  amber: '#ff9400',
  green: '#6DD400',
};

export const greyColours = {
  darkerGrey: '#6C6672',
  darkGrey: '#979797',
  grey: '#C5C7C9',
  transparentGrey: value => {
    return `rgba(197, 199, 201, ${value})`;
  },
  lightGrey: '#E4E3E3',
  lighterGrey: '#FAFAFA',
  darkPurplishGrey: '#A197AB',
  purplishGrey: '#C2BBC8',
  lightPurplishGrey: '#EAE5EF',
  lighterPurplishGrey: '#F7F5F9',
  bluishGrey: '#bedfe1',
};

export const brandColours = {
  primary: '#330066', // dark purple
  transparentPrimary: value => {
    return `rgba(51, 0, 102, ${value})`;
  },
  secondary: '#66FFFF', // light blue
  tertiary: '#FF3366', // dark pink
  quaternary: '#AAFFFF', // lighter blue
  quinary: '#9933FF', // lighter purple
  senary: '#D7FFFF', // lightest blue
  septenary: '#33FFCC', // turquoise
  octonary: '#8466A3', // purple
  nonary: '#17002D', // darker purple
  denary: '#0A0014', // darkest purple
  duodenary: '#F9EDFF', // pastel purple
  tridenary: '#D2B5E8', // lilac
};

export const siteThemeColours = {
  valentines: {
    primary: '#D28988', // dark pink
    secondary: '#E6B1AC', // light pink
    tertiary: '#0C0C0C', // black
    quaternary: '#303030', // dark grey
  },
  mothersDay: {
    primary: '#F57486', // pink
    secondary: '#9EA698', // pale green
  },
  summer: {
    primary: '#FA7661', // orange
  },
  christmas: {
    primary: '#C3132C', // red
    secondary: '#27320D', // green
    tertiary: '#202020', // dark grey
  },
};
